export default __webpack_public_path__ + "static/media/emoji.12df632d.png";